module.exports = __webpack_public_path__ + "img/arrow-down-black.71411a07.svg";